/* src/app/shared/loading-overlay/loading-overlay.component.scss */
.header-h1 {
  font-family: var(--font-family) !important;
  font-weight: 300 !important;
  font-size: 2rem !important;
  color: var(--color-header-name) !important;
}
.header-h2 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: 1.875rem !important;
  color: var(--color-header-name) !important;
}
.header-h3 {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 1.5rem !important;
  color: var(--color-header-name) !important;
}
.header-h4 {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 1.125rem !important;
  color: var(--color-header-name) !important;
}
.header-h5 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: 1rem !important;
  color: var(--color-header-name) !important;
}
.header-h6 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: 0.8125rem !important;
  color: var(--color-header-name) !important;
}
.body-text {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: var(--color-header-name) !important;
}
.small-body-text {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 11.375px !important;
  color: var(--color-header-name) !important;
}
.text-link {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 1rem !important;
  color: var(--color-secondary) !important;
  text-decoration: underline;
}
.text-link:hover {
  color: var(--color-hover) !important;
}
.text-link:visited {
  color: var(--color-visited) !important;
}
.small-text-link {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 0.8125rem !important;
  color: var(--color-secondary) !important;
  text-decoration: underline;
}
.small-text-link:hover {
  color: var(--color-hover) !important;
}
.small-text-link:visited {
  color: var(--color-visited) !important;
}
.label {
  font-family: var(--font-family);
  font-size: 18px;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 0px;
}
.label {
  font-weight: 600;
}
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.24);
  display: grid;
  place-items: center;
  z-index: 10000;
}
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
}
.label {
  color: var(--color-info-title);
}
@media (prefers-reduced-motion: reduce) {
  .mat-mdc-progress-spinner {
    animation: none !important;
  }
}
::ng-deep .custom-spinner .mdc-circular-progress__indeterminate-circle-graphic {
  stroke: #FF6A39 !important;
}
/*# sourceMappingURL=loading-overlay.component.css.map */
